/**
 * Copyright (C) 2019 Olivier Parisot - All Rights Reserved.
 */

import React from 'react';

import EasyDrawing from 'easy-drawing';
//import * as turf from '@turf/turf';

import {lineString} from '@turf/helpers';
import bbox from '@turf/bbox';
import bboxPolygon from '@turf/bbox-polygon';

/**
 * RoutePlot.
 *
 * Author: Olivier Parisot
 */
class RoutePlot extends React.Component 
{
  render() 
  {
    if (this.props.points===null||this.props.points.length===0) return (<br/>);

    const line=lineString(this.props.points);
    const vbbox=bbox(line);
    const vbboxPolygon=bboxPolygon(vbbox);

    const office = {
        polygon: vbboxPolygon.geometry.coordinates[0],
        fillStyle: 'white',
        strokeStyle: 'white'
    }

    const linep2 = {
        symbol:{
            draw: 'fill',
            color: 'red',
            scale: .05,
            rotate: 90
        },
        width: 8,
        points: this.props.points,
        color: this.props.color,
        animation: 'normal'
    }

    return <EasyDrawing areas={[office]} paths={[linep2]}  />;
  }
}


export default RoutePlot;
